import styled from 'styled-components';
export const GoStreakReviewWrapper = styled.div(
  props => `
    background:${
      props.isMweb
        ? 'linear-gradient(135deg, #FFF9F7 0%, #FFF3EF 100%)'
        : props.show_tracker
        ? props.theme.colors.goWhite.base
        : 'linear-gradient(105.63deg, #FFEDE8 -83.64%, #FFFFFF 99.2%)'
    };
    border-radius: ${props.isMweb ? '0.8rem' : '1.2rem'};
    margin-bottom: ${props.isMweb ? '0.8rem' : '1.2rem'};
    overflow: hidden;
    ${
      props.isMweb
        ? ''
        : `
      width: 100%;
      ${props.show_tracker ? 'border: 1px solid rgba(0, 0, 0, 0.1)' : 'border: 1px solid #FFE5DD;'};
    `
    }
    &.complete {
      background: linear-gradient(105.63deg, #FFEDE8 -83.64%, #FFFFFF 99.2%);
      border: 1px solid #FFE5DD;
    }
  `,
);
export const GoStreakDetailsContentWrapper = styled.div(
  props => `
    padding: ${props.isMweb ? '1.2rem' : '1.2rem 2rem'};
    ${props.isMweb ? `background: linear-gradient(135deg, #FFF9F7 0%, #FFF3EF 100%);` : ''}
    .descText {
      font-size: 1.2rem;
      line-height: 1.4rem;
      color: #5B4D49;
    }
  `,
);
export const GoStreakDetailsContenInnerWrapper = styled.div(
  props => `
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding-top: 0.4rem;
    padding-bottom: 1.2rem;
    .leftWrapper {
      .headerText  {
        font-weight: 700;
        font-size: ${props.isMweb ? '1.3rem' : '1.6rem'};
        line-height: 1.9rem;
        color: #5B4D49;
      }
      .complete {
        display: flex;
        align-items:center;
        color: #FF554A;
      }
    }
    .rightWrapper {
      flex-shrink: 0;
    }
  `,
);
export const ValidCheckoutText = styled.div(
  props => `
    font-size: 10px;
    line-height: 12px;
    color: ${props.theme.colors.downriver.medium};
  `,
);
export const GoStreakFeatures = styled.ul(
  props => `
    display: flex;
    align-items:center;
    .featureItem {
      display: flex;
      align-items:center;
      margin-right: 1.2rem;
    }
  `,
);
